module.exports = __webpack_public_path__ + "static/media/video_sign-up-success.b005ab6a.mp4";